// extracted by mini-css-extract-plugin
module.exports = {"resources":"style_resources__EQ_z-"};